(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vpx-stack-chip"] && !Shopify.designMode) return;
  try {
    (function () {
    function reveal(chip) {
      if (chip.dataset.vpxChipBound === '1') return;
      chip.dataset.vpxChipBound = '1';
      if (!('IntersectionObserver' in window)) {
        chip.classList.add('is-in');
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.disconnect();
          setTimeout(function () { chip.classList.add('is-in'); }, 450);
        });
      }, { threshold: 0.9 });
      io.observe(chip);
    }
    function boot() {
      document.querySelectorAll('[data-vpx-stack-chip]').forEach(reveal);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

})();
